import portfolio from "../data/portfolio.json";

/* Static portfolio — generated at build time by scripts/generate-portfolio.js
   from public/portfolio/<client>/ folders. No backend required. */

export const BACKEND_URL = "";

export const usePortfolio = () => ({
  data: portfolio,
  isLoading: false,
  isError: false,
});

export const usePortfolioClient = (slug) => {
  const client = portfolio.find((c) => c.slug === slug) || null;
  return { data: client, isLoading: false, isError: !client };
};
